import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import api from "../../api/axios";

const environmentSocials = {
  instagramUrl: process.env.REACT_APP_INSTAGRAM_URL || "",
  tiktokUrl: process.env.REACT_APP_TIKTOK_URL || "",
  youtubeUrl: process.env.REACT_APP_YOUTUBE_URL || "",
  xUrl: process.env.REACT_APP_X_URL || ""
};

const socialDefinitions = [
  ["Instagram", "instagramUrl", "bi-instagram"],
  ["TikTok", "tiktokUrl", "bi-tiktok"],
  ["YouTube", "youtubeUrl", "bi-youtube"],
  ["X", "xUrl", "bi-twitter-x"]
];

function Footer() {
  const [socials, setSocials] = useState(environmentSocials);

  useEffect(() => {
    api.get("/platform/public-settings")
      .then(({ data }) => setSocials(current => ({ ...current, ...(data?.social || {}) })))
      .catch(() => {});
  }, []);

  const socialLinks = socialDefinitions
    .map(([label, key, icon]) => [label, socials[key], icon])
    .filter(([, url]) => Boolean(url));

  return (
    <footer className="cardora-footer">
      <Container>
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" aria-label="Ir al inicio de Cardora">
              <img src="/assets/cardora-logo.png" alt="Cardora" />
            </Link>
            <p>La comunidad donde las cartas, los binders y las personas se encuentran.</p>
          </div>

          <nav className="footer-column" aria-label="Explorar Cardora">
            <strong>Cardora</strong>
            <Link to="/">Feed</Link>
            <Link to="/landing">Que es Cardora</Link>
            <Link to="/communities">Comunidades</Link>
            <Link to="/reports">Reporte Cardora</Link>
          </nav>

          <nav className="footer-column" aria-label="Accesos de cuenta">
            <strong>Participa</strong>
            <Link to="/register">Crear cuenta</Link>
            <Link to="/login">Entrar</Link>
            <Link to="/stores/register">Registrar tienda</Link>
          </nav>

          <nav className="footer-column" aria-label="Informacion legal">
            <strong>Informacion</strong>
            <Link to="/legal/privacy">Privacidad</Link>
            <Link to="/legal/terms">Terminos</Link>
            <Link to="/legal/cookies">Cookies</Link>
          </nav>
        </div>

        <div className="footer-bottom">
          <span>Cardora {new Date().getFullYear()}</span>
          {socialLinks.length > 0 && (
            <div className="footer-socials" aria-label="Redes sociales de Cardora">
              {socialLinks.map(([label, url, icon]) => (
                <a href={url} target="_blank" rel="noreferrer" aria-label={label} title={label} key={label}>
                  <i className={`bi ${icon}`} />
                </a>
              ))}
            </div>
          )}
          <span>Hecho para la comunidad TCG</span>
        </div>
        <div className="footer-catalog-credit">
          <span>
            Datos de catalogo proporcionados por{" "}
            <a href="https://tcgdex.dev/" target="_blank" rel="noreferrer">TCGdex</a>.
          </span>
          <span>
            Cardora es un proyecto independiente y no esta afiliado con The Pokemon Company,
            Nintendo, Game Freak ni Creatures.
          </span>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
